import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, FolderHeart, Activity } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdrnsDashboard() {
    const { session } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!session) return;
        axios.get(`${API}/adrns/dashboard`, { headers: { Authorization: `Bearer ${session.access_token}` } })
            .then(r => setData(r.data)).catch(() => setData({ error: true }));
    }, [session]);

    if (!data) return <div className="flex justify-center py-20"><Loader2 className="animate-spin" /></div>;

    return (
        <div className="space-y-8" data-testid="adrns-dashboard">
            <div>
                <div className="eyebrow mb-2">ADRNS · Centre d'accompagnement</div>
                <h1 className="font-heading text-4xl">Tableau de bord</h1>
            </div>
            <div className="grid sm:grid-cols-3 gap-5">
                <div className="card-soft p-6">
                    <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Dossiers suivis</div>
                    <div className="font-heading text-4xl text-primary" data-testid="adrns-stat-total">{data.dossiers_total}</div>
                </div>
                <div className="card-soft p-6">
                    <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Dossiers actifs</div>
                    <div className="font-heading text-4xl text-emerald-600" data-testid="adrns-stat-actifs">{data.dossiers_actifs}</div>
                </div>
                <div className="card-soft p-6">
                    <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Votre rôle</div>
                    <div className="font-heading text-2xl capitalize">{data.role}</div>
                </div>
            </div>
            <div className="card-soft p-6">
                <h2 className="font-heading text-2xl mb-4">Activation des modules</h2>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {(data.modules || []).map(m => (
                        <div key={m.id} className="border border-border rounded-lg p-4" data-testid={`adrns-module-stat-${m.id}`}>
                            <div className="text-xs uppercase tracking-wider text-muted-foreground">Module {m.id}</div>
                            <div className="font-medium mt-0.5">{m.nom}</div>
                            <div className="text-2xl font-heading text-primary mt-2">{data.module_counts?.[m.id] ?? 0} <span className="text-sm text-muted-foreground font-sans">dossier(s)</span></div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="card-soft p-6">
                <h2 className="font-heading text-2xl mb-4 flex items-center gap-2"><Activity size={18} /> Dernières interventions</h2>
                {(data.recent_interventions || []).length === 0 ? (
                    <p className="text-sm text-foreground/60">Aucune intervention enregistrée. <Link to="/app/adrns/dossiers" className="text-primary underline">Créez votre premier dossier</Link>.</p>
                ) : (
                    <ul className="space-y-3">
                        {data.recent_interventions.map(i => (
                            <li key={i.id} className="flex items-start gap-3 text-sm">
                                <FolderHeart size={15} className="text-primary mt-0.5 shrink-0" />
                                <div>
                                    <span className="font-medium">{i.porteur_name}</span> — {i.notes?.slice(0, 90)}
                                    <div className="text-xs text-muted-foreground">{i.author_name} · {new Date(i.at).toLocaleString('fr-FR')}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
